import { useCallback, useState } from 'react';
import type { OnChangeFn, SortingState } from '@tanstack/react-table';

const sortingByModelId = new Map<string, SortingState>();

export interface UsePersistedSortingResult {
  sortingParams: SortingState;
  setSortingParams: OnChangeFn<SortingState>;
}

export const usePersistedSorting = (
  modelId: string
): UsePersistedSortingResult => {
  const [sortingParams, setSortingParamsState] = useState<SortingState>(
    () => sortingByModelId.get(modelId) ?? []
  );

  const setSortingParams = useCallback<OnChangeFn<SortingState>>(
    (updater) => {
      setSortingParamsState((prev) => {
        const next = typeof updater === 'function' ? updater(prev) : updater;

        sortingByModelId.set(modelId, next);

        return next;
      });
    },
    [modelId]
  );

  return { sortingParams, setSortingParams };
};
